import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThread: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="thread">
      <path
        d="M5 3H4V5H5V3ZM19 5H20V3H19V5ZM5 19H4V21H5V19ZM19 21H20V19H19V21ZM20.8356 16.9864L21.822 17.1508L22.1508 15.178L21.1644 15.0136L20.8356 16.9864ZM5 4V8.5H7V4H5ZM5 8.5V13.5H7V8.5H5ZM5 13.5V20H7V13.5H5ZM5.8356 9.48639L17.8356 11.4864L18.1644 9.51361L6.1644 7.51361L5.8356 9.48639ZM17 4V10.5H19V4H17ZM17 10.5V15.5H19V10.5H17ZM17 15.5V20H19V15.5H17ZM5 5H6V3H5V5ZM18 5H19V3H18V5ZM5 21H6V19H5V21ZM18 21H19V19H18V21ZM17.8356 16.4864L20.8356 16.9864L21.1644 15.0136L18.1644 14.5136L17.8356 16.4864ZM5.8356 14.4864L17.8356 16.4864L18.1644 14.5136L6.1644 12.5136L5.8356 14.4864ZM12 3.5H14C14 2.39543 13.1046 1.5 12 1.5V3.5ZM12 3.5V1.5C10.8954 1.5 10 2.39543 10 3.5H12ZM6 5H11V3H6V5ZM10 3.5V4H12V3.5H10ZM11 5H13V3H11V5ZM13 5H18V3H13V5ZM12 3.5V4H14V3.5H12ZM11 19H6V21H11V19ZM10 20V20.5H12V20H10ZM18 19H13V21H18V19ZM13 19H11V21H13V19ZM14 20.5V20H12V20.5H14ZM12 22.5C13.1046 22.5 14 21.6046 14 20.5H12V22.5ZM10 20.5C10 21.6046 10.8954 22.5 12 22.5V20.5H10Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconThread;
